// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repeat-cross {
    cursor: pointer;
}

.repeat-cross:hover {
    border-color: var(--bs-primary) !important;
    color: var(--bs-primary) !important;
}

.repeat-add {
    cursor: pointer;
}

.repeat-add:hover {
    border-color: var(--bs-primary) !important;
    color: var(--bs-primary) !important;
}`, "",{"version":3,"sources":["webpack://./src/features/StudyDetails/components/InformationSection/InformationSection.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,mCAAmC;AACvC","sourcesContent":[".repeat-cross {\n    cursor: pointer;\n}\n\n.repeat-cross:hover {\n    border-color: var(--bs-primary) !important;\n    color: var(--bs-primary) !important;\n}\n\n.repeat-add {\n    cursor: pointer;\n}\n\n.repeat-add:hover {\n    border-color: var(--bs-primary) !important;\n    color: var(--bs-primary) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
